<template>
  <v-card>
    <v-banner
      icon="mdi-calendar-refresh"
      single-line
    >
      <h2>Workflow Created Docket Entries Date Change Propagation</h2>
    </v-banner>

    <v-divider />

    <v-card-text
      class="pt-6"
    >
      <p>There are Child Docket Entries created by a Workflow, whoose Action Date you may want to change, given the Parent Docket Entry Action Date was changed.</p>
      <p>Please select, from the list below, which Child Docket Entries Action Date should be changed, if any.</p>
    </v-card-text>

    <v-data-table
      :headers="dataTableHeaders"
      hide-default-footer
      :items="items"
      :items-per-page="-1"
      class="transparent"
    >
      <template
        #header.selected
      >
        <v-checkbox
          :disabled="lockForm"
          :indeterminate="areSomeSelected"
          :value="areAllSelected"
          @click="toggleDocketSelection"
        />
      </template>

      <template
        #item.selected="{ item }"
      >
        <v-checkbox
          v-model="selectedDocketEntries"
          :disabled="lockForm"
          :value="item.id"
        />
      </template>

      <template
        #item.oldDate="{ item }"
      >
        <span class="text-no-wrap">{{ dateDisplayFormat(item.oldDate) }}</span>
      </template>

      <template
        #item.newDate="{ item }"
      >
        <span class="text-no-wrap">{{ dateDisplayFormat(item.newDate) }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import { dateDisplayFormat } from '@/utilities'

import { DOCKET_ENTRY_NAMESPACE } from '@/store/docket-entry'
import { LEGAL_CASE_NAMESPACE } from '@/store/legal-case'
import { unset } from 'lodash'

export default {
  name: 'DocketEntryEditorActionDatePropagation',

  data () {
    return {
      dataTableHeaders: [
        {
          sortable: false,
          text: '',
          value: 'selected',
          width: 0,
        },
        {
          sortable: false,
          text: 'Docket Entry',
          value: 'description',
        },
        {
          class: 'text-no-wrap',
          sortable: false,
          text: 'Current Date',
          value: 'oldDate',
          width: 0,
        },
        {
          class: 'text-no-wrap',
          sortable: false,
          text: 'New Date',
          value: 'newDate',
          width: 0,
        },
      ],

      lockForm: false,
      selectedDocketEntries: [],
    }
  },

  computed: {
    affectedDocketEntries () {
      const relations = (this.docketEntry.child_docket_entry_relations || []).
        filter(r => r.is_protected).
        map(r => r.child_docket_entry_id.toString())

      return Object.keys(this.docketEntriesInfo).
        filter(k => relations.includes(k) && !this.docketEntriesInfo[k].is_done).
        map(k => this.docketEntriesInfo[k])
    },

    areAllSelected () {
      return this.selectedDocketEntries.length === this.affectedDocketEntries.length
    },

    areSomeSelected () {
      return this.selectedDocketEntries.length > 0 && !this.areAllSelected
    },

    differenceInDays () {
      if (!(this.originalDocketEntry.action_date && this.docketEntry.action_date)) return 0
      return (Date.parse(this.docketEntry.action_date) - Date.parse(this.originalDocketEntry.action_date)) / 86400000
    },

    docketEntry () {
      return this.editedDocketEntry
    },

    items () {
      return (this.affectedDocketEntries || []).map(d => {
        return {
          description: `${d.action_type} #${d.id} - ${d.title}`,
          id: d.id,
          newDate: (new Date(Date.parse(d.action_date) + (this.differenceInDays || 0) * 86400000)).
            toISOString().
            substring(0, 10),
          oldDate: d.action_date,
        }
      })
    },

    ...mapGetters(DOCKET_ENTRY_NAMESPACE, [
      'editedDocketEntry',
      'originalDocketEntry',
    ]),

    ...mapGetters(LEGAL_CASE_NAMESPACE, [
      'docketEntriesInfo',
    ]),
  },

  watch: {
    selectedDocketEntries (val) {
      this.docketEntry.child_docket_entry_relations.forEach(cder => {
        if (val.includes(cder.child_docket_entry_id)) {
          const de = this.docketEntriesInfo[cder.child_docket_entry_id]

          cder.child_docket_entry = {
            action_date: (new Date(Date.parse(de.action_date) + (this.differenceInDays || 0) * 86400000)).
              toISOString().
              substring(0, 10),
            id: de.id,
          }
        } else if (cder.child_docket_entry) {
          unset(cder, 'child_docket_entry')
        }
      })
    },
  },

  methods: {
    dateDisplayFormat,

    toggleDocketSelection () {
      if (this.areAllSelected) this.selectedDocketEntries = []
      else this.selectedDocketEntries = this.affectedDocketEntries.map(d => d.id)
    },
  },
}
</script>
